var _style, _g, _circle, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path7, _ellipse10, _ellipse11, _ellipse12, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 248",
    style: {
      enableBackground: "new 0 0 248 248"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.3;fill:url(#SVGID_4_);enable-background:new    ;}\n\t\n\t\t.st5{opacity:0.4;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t\n\t\t.st6{opacity:0.6;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t\n\t\t.st7{opacity:0.1;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st8{opacity:0.3;fill:url(#SVGID_5_);enable-background:new    ;}\n\t.st9{opacity:0.3;fill:url(#SVGID_6_);enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 125.94992,
    cy: 122.00809,
    r: 87.56506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CFF0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    style: {
      stopColor: "#CFF0EF",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 125.94992,
    cy: 122.00809,
    r: 87.56506
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.69958,
    y1: 81.03172,
    x2: 170.88702,
    y2: 164.23837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0011,
    style: {
      stopColor: "#19B7B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19B7B3",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.15681,122.631c0,10.28799-2.53,19.972-6.99899,28.489c-1.22301,2.319-2.586,4.554-4.09,6.67599 c-6.282,8.995-14.92599,16.205-25.017,20.77299c-1.687,0.759-3.401,1.448-5.172,2.052 c-6.282,2.19299-13.043,3.373-20.08401,3.373c-15.924,0-30.414-6.058-41.307-15.994c-2.755-2.502-5.27-5.256-7.519-8.222 c-7.856-10.302-12.523-23.17599-12.523-37.146c0-7.646,1.391-14.954,3.949-21.7c1.068-2.853,2.361-5.594,3.823-8.208 c0-0.014,0-0.014,0-0.014c10.499-18.749,30.555-31.426,53.576-31.426c11.03301,0,21.37701,2.909,30.316,7.997 c1.616,0.914,3.17599,1.897,4.67999,2.952c6.901,4.807,12.776,10.991,17.203,18.145c1.95399,3.148,3.62601,6.479,4.989,9.979 C185.68182,107.255,187.15681,114.774,187.15681,122.631z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 128.55492,
    cy: 125.3722,
    r: 61.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0011,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19B7B3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.33083,122.686c0,10.29-2.53,19.97401-7,28.48901c-0.41499,0.78999-0.85001,1.565-1.295,2.33501 c-0.78999,1.355-1.63,2.675-2.52,3.955c-0.09,0.13-0.185,0.25999-0.27499,0.39c-6.285,8.995-14.924,16.205-25.019,20.769 c-0.39999,0.17999-0.80499,0.36-1.21001,0.53c-1.10001,0.47-2.215,0.91-3.355,1.31c-0.2,0.075-0.39999,0.145-0.605,0.215 c-6.285,2.19-13.045,3.37-20.08401,3.37c-15.925,0-30.414-6.05499-41.309-15.995c-1.565-1.42-3.055-2.925-4.46-4.505 c-1.07-1.19501-2.09-2.435-3.06-3.715c-0.2-0.25999-0.395-0.52499-0.585-0.78999c-7.505-10.16499-11.935-22.739-11.935-36.359 c0-7.645,1.39-14.95,3.95-21.699c0.07-0.185,0.14-0.37,0.21-0.55c0.575-1.5,1.22-2.965,1.915-4.4 c0.535-1.105,1.1-2.19,1.695-3.255c0-0.015,0-0.015,0-0.015c10.5-18.749,30.554-31.429,53.578-31.429 c11.03001,0,21.374,2.91,30.314,8c0.10001,0.055,0.2,0.115,0.295,0.17c1.08501,0.62,2.145,1.275,3.17999,1.965 c0.405,0.265,0.81,0.535,1.205,0.815c6.89999,4.81,12.77499,10.99,17.20399,18.144c0.535,0.86,1.045,1.73,1.53,2.615 l2.74001,5.605c0.25,0.58,0.49001,1.17,0.72,1.76C185.85481,107.311,187.33083,114.831,187.33083,122.686z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.43582,98.651c-11.06-7.03-23.174-10.97-34.084-10.97c-19.944,0-39.02401,9.96-52.35901,27.329 c-10.96,14.28001-16.409,31.339-15.794,48.53901c-1.07-1.19501-2.09-2.435-3.06-3.715c-0.2-0.25999-0.395-0.52499-0.585-0.78999 c-0.45-18.29401,6.04-36.344,18.379-50.534c13.385-15.395,32.104-24.224,51.358-24.224c11.34,0,22.55901,2.945,33.40399,8.76 L182.43582,98.651z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.03581,153.50999c-0.78999,1.355-1.63,2.675-2.52,3.955c-6.215,1.03999-12.455,1.565-18.634,1.565 c-41.80901,0-77.76801-23.879-89.10201-58.593c0.575-1.5,1.22-2.965,1.915-4.4c9.42,33.359,47.653,59.46799,88.99702,59.46799 C166.29082,155.505,172.77081,154.83501,179.03581,153.50999z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.01183,179.15401c-1.10001,0.47-2.215,0.91-3.355,1.31c-5.53-16.834-7.985-36.939-6.77-56.16299 c0.97501-15.5,4.72-37.049,16.69-54.793c1.08501,0.62,2.145,1.275,3.17999,1.965 C140.30682,102.586,140.01682,147.965,150.01183,179.15401z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.27532 -0.96135 0.96135 0.27532 26.96128 204.1321)",
    className: "st3",
    cx: 148.88045,
    cy: 84.18276,
    rx: 9.58544,
    ry: 12.07429
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2195 -0.97561 0.97561 0.2195 -56.54976 179.43723)",
    className: "st3",
    cx: 83.87201,
    cy: 125.06178,
    rx: 12.07482,
    ry: 9.91484
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.99181,
    y1: 124.26814,
    x2: 18.81182,
    y2: 121.70364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.26781,126.605c-1.04,4.62-4.955,7.67001-8.745,6.81499c-0.055-0.00999-0.105-0.02499-0.16-0.03999 c-4.885,1.705-35.13499,12.66-62.929,23.11c-15.93-18.91901-4.308-69.785-4.308-69.785l71.156,30.001 C89.07281,117.556,91.30281,121.991,90.26781,126.605z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.96361 -0.2673 0.2673 0.96361 -36.89958 43.872)",
    className: "st3",
    cx: 142.69379,
    cy: 157.4696,
    rx: 12.07481,
    ry: 10.29783
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2195 -0.97561 0.97561 0.2195 -79.76064 148.11098)",
    className: "st5",
    cx: 52.6879,
    cy: 123.90527,
    rx: 19.49971,
    ry: 16.01176
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2195 -0.97561 0.97561 0.2195 -67.95207 162.93933)",
    className: "st6",
    cx: 67.85979,
    cy: 123.93919,
    rx: 13.5618,
    ry: 11.13584
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2195 -0.97561 0.97561 0.2195 -93.78543 129.9872)",
    className: "st7",
    cx: 34.34829,
    cy: 123.60877,
    rx: 26.38962,
    ry: 21.66967
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.94966 -0.31329 0.31329 0.94966 -50.02826 58.91029)",
    className: "st5",
    cx: 158.29077,
    cy: 185.12276,
    rx: 19.5009,
    ry: 16.01273
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.94966 -0.31329 0.31329 0.94966 -46.33677 55.81959)",
    className: "st6",
    cx: 150.5195,
    cy: 172.09099,
    rx: 13.56262,
    ry: 11.13652
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.94966 -0.31329 0.31329 0.94966 -54.54222 62.58442)",
    className: "st7",
    cx: 167.46619,
    cy: 201.00545,
    rx: 26.39121,
    ry: 21.671
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -5991.86328,
    y1: -4168.71826,
    x2: -6053.04346,
    y2: -4171.28223,
    gradientTransform: "matrix(-0.4032 0.9151 -0.9151 -0.4032 -6079.05371 3882.03711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M147.02582,10.318c23.73601-6.949,65.59801,24.196,65.59801,24.196l-56.14401,53.019 c-2.306,3.125-7.263,3.378-11.069,0.57c-3.808-2.814-5.021-7.627-2.71001-10.75c0.03101-0.046,0.065-0.086,0.101-0.13 C143.21082,72.065,145.38182,39.966,147.02582,10.318"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.59421 -0.80431 0.80431 0.59421 22.07945 153.3584)",
    className: "st5",
    cx: 163.02434,
    cy: 54.79753,
    rx: 16.01177,
    ry: 19.49973
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.59421 -0.80431 0.80431 0.59421 8.42855 154.04175)",
    className: "st6",
    cx: 156.87613,
    cy: 68.66783,
    rx: 11.13585,
    ry: 13.56181
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.59421 -0.80431 0.80431 0.59421 38.59188 152.76175)",
    className: "st7",
    cx: 170.68925,
    cy: 38.13469,
    rx: 21.66971,
    ry: 26.38963
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -18935.93555,
    y1: 622.13818,
    x2: -19000.16016,
    y2: 619.44617,
    gradientTransform: "matrix(-0.5471 -0.8371 0.8371 -0.5471 -10731.71973 -15349.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.33482,196.908c-7.12199,23.685-43.38782,41.785-43.38782,41.785l-26.48718-75.976 c-1.362-3.63699,1.13-7.92999,5.56-9.589c4.436-1.657,9.131-0.049,10.489,3.592c0.022,0.05099,0.036,0.10201,0.054,0.15601 C154.66081,160.032,180.38081,179.35899,204.33482,196.908"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.d78d5d0e7ddc21581a2600fb474e1c7a.svg";
export { ForwardRef as ReactComponent };